import React, { useState } from 'react'
import { FiEdit } from 'react-icons/fi'
import { FaRegSave } from 'react-icons/fa'
import { toast } from 'react-toastify'

import Spinner from '../../../components/Spinner'
import Modal from '../../../components/Modal'
import FormEndereco from '../../../components/FormEndereco'

import stringUtils from '../../../util/string'

import { api, authHeaders } from '../../../services/api'

import { Container } from './styles'
import masks from '../../../util/masks'

const boxName = 'Endereço'

const baseInitialValues = {
    cep: '',
    uf: '',
    cidade: '',
    bairro: '',
    rua: '',
    numero: '',
    complemento: ''
}

export default function ({ pessoa, reload, editable = true, className = '' }) {
    const [editMode, setEditMode] = useState(false)
    const [submitting, setSubmitting] = useState(false)
    const [initialValues, setInitialValues] = useState(baseInitialValues)

    function handlePrepareEdit() {
        if (pessoa.endereco) {
            const {
                cep, uf, cidade, bairro, rua, numero, complemento
            } = pessoa.endereco

            setInitialValues({
                cep: masks.maskApply.cep(cep),
                uf,
                cidade,
                bairro,
                rua,
                numero,
                complemento: complemento || ''
            })
        }

        setEditMode(true)
    }

    async function handleEdit(values) {
        setSubmitting(true)

        values.uf = values.uf.value
        values.cidade = values.cidade.value

        try {

            if (pessoa.endereco) {
                await api.put(`endereco/${pessoa.endereco.id}`, values, authHeaders())
            } else {
                values.pessoa_id = pessoa.id
                await api.post(`endereco/`, values, authHeaders())
            }

            toast.success('Endereço atualizado.')

            setEditMode(false)

            setInitialValues(baseInitialValues)

            reload()
        } catch (e) {
            console.log(e)

            toast.error('Erro ao atualizar o endereço.')
        }

        setSubmitting(false)
    }

    return (
        <>
            <Container className={`animated fadeInUp delay-300ms no-responsive bg-white text-slate-500 ${className}`}>
                    <h1 className="text-slate-800">{boxName}</h1>

                    {editable ? (
                        <div
                            className="flex items-center gap-1.5 cursor-pointer hover:opacity-80 w-fit hover:bg-slate-100 rounded-md px-4 py-2 justify-self-end"
                            onClick={handlePrepareEdit}
                        >
                            <FiEdit
                                size={18}
                                color="#1e293b"
                            />

                            <span className="text-center text-xs">Editar</span>
                        </div>
                    ) : (
                        <div />
                    )}

                {pessoa ? (
                    <div className="endereco">
                        {pessoa.endereco && Object.entries(pessoa.endereco).filter(([key]) => key !== 'id').map(([key, value]) => (
                            <span key={key}>
                                <b>{['cep', 'uf'].includes(key) ? key.toUpperCase() : key === 'numero' ? 'Número' : stringUtils.capitalize(key)}</b>
                                :
                                {' '}
                                {value}
                            </span>
                        ))}
                    </div>
                ) : (
                    <Spinner />
                )}
            </Container>

            <Modal
                isOpen={editMode}
                handleClose={() => setEditMode(false)}
                title={boxName}
            >
                <FormEndereco
                    onSubmit={handleEdit}
                    buttonDisabled={submitting}
                    buttonContent={(
                        <>
                            Salvar alterações
                            <FaRegSave color="#fff" size={16} />
                        </>
                    )}
                    defaultValues={initialValues}
                />
            </Modal>
        </>
    )
}
